import React from 'react';
import './footer.scss';
import logo from '../../assets/navbar/logoremala.png';
import awardsIntegrasi from '../../assets/iso/Integrasi.png';
import awards9001 from '../../assets/iso/ISO-9001.png';
import awards14001 from '../../assets/iso/ISO-14001.png';
import awards27001 from '../../assets/iso/ISO-27001.png';
import awards37001 from '../../assets/iso/ISO-37001.png';
import awards45001 from '../../assets/iso/ISO-45001.png';
import awards20000 from '../../assets/iso/ISO-20000.jpeg';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { Link, useNavigate } from 'react-router-dom';

const FooterEn = () => {
  const navigate = useNavigate();

  const handleToIntegrasi = () => {
    navigate(`/en/corporate-governance/quality-management/7/ims-00241`);
  };

  const handleTo9001 = () => {
    navigate(`/en/corporate-governance/quality-management/4/iso-9001`);
  };

  const handleTo37001 = () => {
    navigate(`/en/corporate-governance/quality-management/5/iso-37001`);
  };

  const handleTo27001 = () => {
    navigate(`/en/corporate-governance/quality-management/2/iso-27001`);
  };

  const handleTo45001 = () => {
    navigate(`/en/corporate-governance/quality-management/3/iso-45001`);
  };

  const handleTo14001 = () => {
    navigate(`/en/corporate-governance/quality-management/1/iso-14001`);
  };

  const handleTo20000 = () => {
    navigate(`/en/corporate-governance/quality-management/6/iso-20000-1`);
  };

  return (
    <>
      <div className="mainFooter stickyFooter">
        <div className="footerTop">
          <div className="footerLeft">
            <div className="firstLeft">
              <img src={logo} alt="Remala" className="logoFooter" />
              <div className="awardsImage">
                <img src={awardsIntegrasi} alt="Remala" className="awards" onClick={handleToIntegrasi} />
                <img src={awards9001} alt="Remala" className="awards" onClick={handleTo9001} />
                <img src={awards37001} alt="Remala" className="awards" onClick={handleTo37001} />
              </div>
              <div className="awardsImage">
                <img src={awards27001} alt="Remala" className="awards" onClick={handleTo27001} />
                <img src={awards45001} alt="Remala" className="awards" onClick={handleTo45001} />
                <img src={awards14001} alt="Remala" className="awards" onClick={handleTo14001} />
              </div>
              <img src={awards20000} alt="iso20000" className="logoAcs" onClick={handleTo20000} />
            </div>
            <div className="twoLeft">
              <h6>
                <strong>PT. Remala Abadi Tbk</strong>
              </h6>
              <p>Graha Mustika Ratu</p>
              <p>
                Jl. Gatot Subroto No 74-75, RT 02/ RW 01. <br />
                Menteng Dalam, Kec. Tebet, Kota Jakarta Selatan, <br />
                Daerah Khusus Ibukota Jakarta 12870
              </p>
              <br />
              <p>Phone : (021) 83708889</p>
              <p>Email : corporatesecretary@remala.id</p>
              {/* <p>
                <h5>Visit Our Office :</h5>
              </p>
              <p>Monday – Saturday</p>
              <p>09 AM – 05 PM</p> */}
            </div>
          </div>
          <span className="borderLine"></span>
          <div className="footerMidle">
            <div className="pengumuman">
              <h6>Announcements</h6>
              <a href="/en/investor-relation/activity/issuer-announcement">RUPS Announcements</a>
              <a href="/en/investor-relation/memo-information/memo-announcement">Public Disclosure Announcements</a>
              <a href="/en/investor-relation/activity/issuer-announcement">Issuer Announcements</a>
            </div>
            <div className="laporan">
              <h6>Reports</h6>
              <a href="/en/investor-relation/report/financial-statements">Financial Reports</a>
              <a href="#">Sustainability Reports</a>
              <a href="/en/investor-relation/report/annual-report">Annual Reports</a>
            </div>
            <div className="tautan">
              <h6>Important Links</h6>
              <a href="/en/aboutus/profile">About Us</a>
              <a href="/en/investor-relation/stock-information/stock-volume">Investor Relations</a>
              <a href="/en/corporate-governance/quality-management">Management</a>
            </div>
          </div>

          <div className="footerRight">
            <div className="rightTop">
              <h3>FOLLOW US</h3>
            </div>
            <div className="rightBottom">
              <a href="#">
                <InstagramIcon className="icon" />
              </a>
              <a href="#">
                <FacebookOutlinedIcon className="icon" />
              </a>
              <a href="#">
                <YouTubeIcon className="icon" />
              </a>
              <a href="#">
                <LinkedInIcon className="icon" />
              </a>
            </div>
          </div>
        </div>
        <hr />
        <div className="footerBottom">
          <p>Copyright &copy; Remala Group {new Date().getFullYear()} All Right Reserved</p>
        </div>
      </div>
    </>
  );
};

export default FooterEn;
